/// <reference path="../../Common/Helpers/GridEditorDialog.ts" />

namespace Matrix.Indexation {

    @Serenity.Decorators.registerClass()
    export class BasketConstituentsEditorDialog extends Common.GridEditorDialog<BasketConstituentRow> {
        protected getFormKey() { return BasketConstituentForm.formKey; }
        protected getIdProperty() { return BasketConstituentRow.idProperty; }
        protected getLocalTextPrefix() { return BasketConstituentRow.localTextPrefix; }
        protected getNameProperty() { return BasketConstituentRow.nameProperty; }
        protected getDeletePermission() { return BasketConstituentRow.deletePermission; }
        protected getInsertPermission() { return BasketConstituentRow.insertPermission; }
        protected getUpdatePermission() { return BasketConstituentRow.updatePermission; }

        protected form = new BasketConstituentForm(this.idPrefix);

    }
}